// Globals
import { Form, Input } from 'antd';
import MaskedInput from 'antd-mask-input';

// Components
import { StyledFormWrap, StyledFormItem, StyledButton } from './UserFormContainerStyles';

// Models
import { TFormFields } from '@/models/chat.model';

// Helpers
import { validateUSPhone } from '@/utils';
import { TUserDataFormValues } from '../../helpers';

type TUserFormContainer = {
  formFields: TFormFields[];
  handleSubmit: (value: TUserDataFormValues) => void;
}

const UserFormContainer = ({ formFields, handleSubmit }: TUserFormContainer) => {

  if (!formFields) return null;

  const renderFormItem = (item: TFormFields) => {
    switch (true) {
      case item.name === 'phone':
        return (
          <StyledFormItem
              key={item.name}
              label={item.name.charAt(0).toUpperCase() + item.name.slice(1)}
              name={item.name}
              rules={[
                {
                  required: true,
                  message: item.message,
                },
                { validator: validateUSPhone },
              ]}
            >
              <MaskedInput mask="+1 (000) 000-0000" placeholder={item.placeholder} />
          </StyledFormItem>
        );
      default:
        const regex = new RegExp(item.regex);
        return (
          <StyledFormItem
            key={item.name}
            label={item.name.charAt(0).toUpperCase() + item.name.slice(1)}
            name={item.name}
            rules={[{
              required: true,
              min: item?.min,
              max: item?.max,
              pattern: regex,
              message: item.message,
            }]}
          >
            <Input placeholder={item.placeholder} />
        </StyledFormItem>
      )
    }
  };

  return (
    <StyledFormWrap>
      <Form
        layout='vertical'
        onFinish={handleSubmit}
      >
        {formFields.map((item) => {
          return (
            <>
              {renderFormItem(item)}
            </>
          )
        })}
        <StyledButton htmlType='submit'>
          Proceed
        </StyledButton>
      </Form>
    </StyledFormWrap>
  );
};

export default UserFormContainer;
